export default "__VITE_ASSET__DDz3S49h__"